import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle, ShoppingBag, Package } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useCartStore } from '@/store';
import { useCustomerAuth } from '@/hooks/useCustomerAuth';

const OrderConfirmationPage = () => {
  const { clearCart } = useCartStore();
  const { isLoggedIn } = useCustomerAuth();

  useEffect(() => {
    clearCart();
  }, [clearCart]);

  return (
    <div className="min-h-screen pt-24 pb-16 px-6 flex items-center justify-center">
      <div className="max-w-xl w-full text-center">
        <motion.div
          initial={{ scale: 0.5, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ type: 'spring', stiffness: 200, damping: 18 }}
          className="flex justify-center mb-8"
        >
          <CheckCircle className="w-24 h-24 text-accent" strokeWidth={1.5} />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.25 }}
        >
          <h1 className="font-heading text-4xl md:text-5xl font-bold text-text-primary mb-4">
            Pedido Confirmado!
          </h1>
          <p className="text-lg text-text-secondary mb-10">
            Obrigada pela sua compra. Você receberá um e-mail de confirmação em breve com os detalhes do seu pedido.
          </p>

          <div className="bg-white rounded-2xl shadow-sm p-8 mb-8 text-left space-y-4">
            <div className="flex items-start gap-3">
              <Package className="w-5 h-5 text-accent mt-0.5 shrink-0" />
              <p className="text-text-secondary text-sm">
                Seu pedido está sendo processado e será enviado assim que o pagamento for confirmado.
              </p>
            </div>
            <div className="flex items-start gap-3">
              <ShoppingBag className="w-5 h-5 text-accent mt-0.5 shrink-0" />
              <p className="text-text-secondary text-sm">
                {isLoggedIn
                  ? 'Acompanhe o status do seu pedido em "Meus Pedidos".'
                  : 'Crie uma conta ou faça login para acompanhar o status do seu pedido.'}
              </p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            {isLoggedIn ? (
              <Link to="/pedidos">
                <Button className="bg-accent text-white hover:bg-accent/90 rounded-full px-10 py-6 text-lg w-full sm:w-auto">
                  Meus Pedidos
                </Button>
              </Link>
            ) : (
              <Link to="/login">
                <Button className="bg-accent text-white hover:bg-accent/90 rounded-full px-10 py-6 text-lg w-full sm:w-auto">
                  Fazer Login
                </Button>
              </Link>
            )}
            <Link to="/produtos">
              <Button variant="outline" className="rounded-full px-10 py-6 text-lg w-full sm:w-auto">
                Continuar Comprando
              </Button>
            </Link>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default OrderConfirmationPage;
